import React from 'react';

const NotFound = props => {
  return (
    <>
      <label>This Page Does Not Exist!</label>
    </>
  );
};

export default NotFound;
